const segmentedControlVariants = {
    settlementStatusFilters: {
        root: {
            $extendFromVariant: "default",
            flexDirection: ["row", "column", "column"],
            height: "auto",
            width: ["auto", "142px", "195px"],
            backgroundColor: "$black",
            overflowX: "auto",
            borderRadius: 0,
        },
        segment: {
            marginBottom: "$s1",
            paddingTop: "$s1",
            paddingRight: "$s2",
            paddingBottom: "$s1",
            paddingLeft: "$s2",
            color: "$gray400",
            backgroundColor: "$black",
            textTransform: "uppercase",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "18px",
            borderWidth: 0,
            textAlign: "left",
            transform: "none",
            cursor: "pointer",
        },
        "segment:selected": {
            marginBottom: "$s1",
            paddingTop: "$s1",
            paddingRight: "$s2",
            paddingBottom: "$s1",
            paddingLeft: "$s2",
            textTransform: "uppercase",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "18px",
            borderRadius: ["0", "8px", "8px"],
            color: "$white",
            backgroundColor: ["#000000", "#252525", "#252525"],
            borderColor: "$green400",
            borderWidth: "0",
            borderBottomWidth: ["2px", "0", "0"],
            textAlign: "left",
            transform: "none",
            borderStyle: "solid",
            cursor: "pointer",
        }
    },
    "settlementStatusFilters:Disabled": {
        $extendFromVariant: "settlementStatusFilters",
        segment: {
            cursor: "not-allowed",
        },
        "segment:selected": {
            cursor: "not-allowed",
        }
    }
};
export { segmentedControlVariants };
//# sourceMappingURL=segmentedControl.js.map